export default __webpack_public_path__ + "static/media/dummy.066b3bfb.png";